var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDai(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 71,
    viewBox: "0 0 72 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2_184)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 11.2567,
    y: 7.70813,
    width: 49.7,
    height: 49.7,
    rx: 24.85,
    fill: "#F5AC37"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_184)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.4568 17.5081C44.9627 17.5081 51.8568 24.4035 51.8568 32.9081C51.8568 41.414 44.9627 48.3081 36.4568 48.3081C27.9522 48.3081 21.0568 41.4133 21.0568 32.9081C21.0568 24.4035 27.9522 17.5081 36.4568 17.5081Z",
    fill: "#F5AC37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.024 33.9955H42.8757C43.0005 33.9955 43.0594 33.9955 43.0684 33.8319C43.1162 33.2366 43.1162 32.6379 43.0684 32.0419C43.0684 31.9261 43.0109 31.8783 42.8854 31.8783H31.2394C31.0953 31.8783 31.0565 31.9261 31.0565 32.0613V33.7744C31.0565 33.9955 31.0565 33.9955 31.2873 33.9955H37.024ZM42.4149 29.8762C42.4315 29.8326 42.4315 29.7848 42.4149 29.7418C42.3172 29.529 42.2014 29.326 42.067 29.1354C41.8646 28.8097 41.6262 28.5096 41.3546 28.24C41.2264 28.0772 41.0781 27.931 40.9117 27.8069C40.0787 27.098 39.0884 26.5962 38.024 26.344C37.4869 26.2234 36.938 26.1659 36.3878 26.1707H31.2193C31.0752 26.1707 31.0558 26.2282 31.0558 26.3537V29.7702C31.0558 29.9143 31.0558 29.9532 31.2387 29.9532H42.3456C42.3456 29.9532 42.4419 29.9337 42.4613 29.8762H42.4142H42.4149ZM42.4149 35.9976C42.2513 35.9795 42.0864 35.9795 41.9228 35.9976H31.2491C31.105 35.9976 31.0565 35.9976 31.0565 36.1902V39.5305C31.0565 39.6844 31.0565 39.7232 31.2491 39.7232H36.1771C36.4127 39.7412 36.6484 39.7245 36.8791 39.6753C37.5943 39.6241 38.2977 39.4688 38.9685 39.2131C39.2125 39.1286 39.4481 39.0184 39.6706 38.886H39.7378C40.893 38.2852 41.8314 37.3413 42.4232 36.1826C42.4232 36.1826 42.4904 36.0371 42.4149 35.9989V35.9976ZM29.1223 41.455V41.3975V39.1549V38.3947V36.1327C29.1223 36.0073 29.1223 35.9886 28.9685 35.9886H26.8797C26.764 35.9886 26.7162 35.9886 26.7162 35.8347V34.0059H28.9491C29.0738 34.0059 29.1223 34.0059 29.1223 33.8423V32.0329C29.1223 31.9171 29.1223 31.8887 28.9685 31.8887H26.8797C26.764 31.8887 26.7162 31.8887 26.7162 31.7349V30.0412C26.7162 29.9351 26.7162 29.9067 26.87 29.9067H28.9394C29.0835 29.9067 29.1223 29.9067 29.1223 29.7238V24.5359C29.1223 24.3821 29.1223 24.3433 29.315 24.3433H36.5333C37.0572 24.3641 37.5777 24.4216 38.0926 24.5165C39.1536 24.7126 40.173 25.0917 41.1051 25.6329C41.7233 25.9968 42.2922 26.4361 42.7988 26.942C43.18 27.3377 43.5237 27.766 43.8286 28.222C44.1315 28.6843 44.383 29.1784 44.5805 29.6947C44.6048 29.8291 44.7337 29.9199 44.8681 29.897H46.5909C46.812 29.897 46.812 29.897 46.8217 30.1091V31.6877C46.8217 31.8416 46.7642 31.8804 46.6096 31.8804H45.2812C45.1467 31.8804 45.1079 31.8804 45.1176 32.0537C45.1703 32.6399 45.1703 33.2283 45.1176 33.8146C45.1176 33.9781 45.1176 33.9975 45.3012 33.9975H46.821C46.8882 34.0842 46.821 34.1708 46.821 34.2581C46.8307 34.3697 46.8307 34.4826 46.821 34.5942V35.7592C46.821 35.9227 46.7732 35.9712 46.6284 35.9712H44.8092C44.6824 35.947 44.559 36.0281 44.5299 36.1542C44.0968 37.2803 43.4038 38.29 42.5084 39.0995C42.1813 39.394 41.8376 39.6712 41.4786 39.9269C41.0933 40.1487 40.7184 40.3794 40.3234 40.5624C39.5964 40.8895 38.8341 41.1307 38.0517 41.2838C37.3088 41.4169 36.5555 41.4772 35.7994 41.4668H29.1195V41.4571L29.1223 41.455Z",
    fill: "#FEFEFD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2_184",
    x: 0.756714,
    y: 0.00812984,
    width: 70.7,
    height: 70.7,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2_184"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2_184",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_184"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 21.0568,
    y: 17.5081,
    width: 30.8,
    height: 30.8,
    rx: 15.4,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDai);
export default __webpack_public_path__ + "static/media/dai.e5ffec83391e72df1c22cffc51ee5975.svg";
export { ForwardRef as ReactComponent };